import { graphql } from "react-relay";
import "../room-preferences-settings";
export const fragments = {
  viewer: graphql`
    fragment RoomPreferencesSettings_viewer on Viewer
    @argumentDefinitions(
      queryInput: { type: "String!", defaultValue: "" }
      orgRelayId: { type: "ID!", defaultValue: "" }
      excludeCalendars: { type: "[String!]!", defaultValue: [] }
    ) {
      roomQueryResult(
        query: $queryInput
        orgRelayId: $orgRelayId
        excludeCalendars: $excludeCalendars
      ) {
        __typename
        ... on GraphEntityError {
          message
          statusCode
        }
        ... on ExternalRoomSearchResult {
          searchQuery
          cacheable
          rooms {
            roomId
            name
            orgId
            estimatedCapacity
            reportedCapacity
          }
        }
      }
    }
  `,
  org: graphql`
    fragment RoomPreferencesSettings_org on Org {
      id
      suggestedRoomPreferences {
        __typename
        ... on GraphEntityError {
          message
          statusCode
        }
        ... on SuggestedRoomPreferences {
          suggestedRooms {
            isPreferred
            isSuggested
            room {
              roomId
              name
              orgId
              estimatedCapacity
              reportedCapacity
            }
          }
        }
      }
    }
  `,
};

export const query = graphql`
  query RoomPreferencesSettingsQuery(
    $queryInput: String!
    $orgRelayId: ID!
    $excludeCalendars: [String!]!
  ) {
    viewer {
      ...RoomPreferencesSettings_viewer
        @arguments(
          queryInput: $queryInput
          orgRelayId: $orgRelayId
          excludeCalendars: $excludeCalendars
        )
    }
  }
`;
